// src/services/visitCheckService.js
//
// Frontend API wrapper for visit check/uncheck operations.
// =============================================================================
//
// IMPORTANT
// ---------
// Checking a visit is not a simple boolean field update anymore. It may trigger
// automatic material consumption and stock movements. This wrapper makes that
// domain intent explicit for ManagePage while backend remains authoritative.

import apiClient from "../utils/apiClient";
import { idempotentPost } from "../utils/idempotentStockPosting";

const DEBUG_API =
  String(process.env.REACT_APP_DEBUG_API || "").toLowerCase().trim() === "true";

function getErrorMessage(err) {
  const apiMsg =
    err?.response?.data?.message ||
    err?.response?.data?.error ||
    err?.response?.data?.detail;

  return apiMsg || err?.message || "Request failed";
}

function throwApiError(context, err) {
  const message = getErrorMessage(err);
  const e = new Error(`${context}: ${message}`);

  e.status = err?.response?.status;
  e.data = err?.response?.data || err?.data;
  e.outcomeUnknown = Boolean(err?.outcomeUnknown || e.data?.outcome_unknown);
  e.code = err?.response?.data?.code || err?.code;

  if (DEBUG_API) {
    // eslint-disable-next-line no-console
    console.error(`[VisitCheckService] ${context}`, {
      status: e.status,
      code: e.code,
      message,
      data: e.data,
    });
  }

  throw e;
}

function assertVisitId(context, visitId) {
  if (visitId === undefined || visitId === null || `${visitId}`.trim() === "") {
    const e = new Error(`${context}: visitId is required.`);
    e.code = "VISIT_ID_MISSING";
    throw e;
  }
}

export const checkVisit = async (visitId) => {
  try {
    assertVisitId("checkVisit", visitId);

    const res = await idempotentPost(apiClient, `/visits/${visitId}/check`, {}, {
      withCredentials: true,
    });

    return res?.data;
  } catch (err) {
    throwApiError("checkVisit", err);
  }
};

export const uncheckVisit = async (visitId) => {
  try {
    assertVisitId("uncheckVisit", visitId);

    const res = await idempotentPost(apiClient, `/visits/${visitId}/uncheck`, {}, {
      withCredentials: true,
    });

    return res?.data;
  } catch (err) {
    throwApiError("uncheckVisit", err);
  }
};


